import { Card ,Row,Col, Divider,Button, Typography, message,Select,DatePicker,Form} from "antd";
import React, { Component } from "react";
import Chart from "react-apexcharts";
import storage from "../../utils/storage";
import { configs } from "../../config/config";
import {getActivityPie, getDeviceActivityDaily, getDeviceNumsByCid } from "../../model/dashboard/requests";
import { defaultColors,defaultDropShadow,defaultStroke } from "../../model/dashboard/datasource";
import { formatDateString } from "../../utils/utils";
import { getGroup } from "../../model/group/requests";
const {Title} = Typography
const {Option} = Select;
const  {RangePicker} = DatePicker;
class DashBoardActivity extends Component {
    constructor(props){
        super(props)
        this.state = {
          options_chart1:{},
          series_chart1:[],
          options_chart2:{},
          series_chart2:[],
          options_chart3:{},
          series_chart3:[],
          customList:[],
          filterCustom:0,
          filterDate:[]
        }      
        
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    componentDidMount(){
      let options_chart1 = {
        labels: [],
        stroke: { width: 0 },
        title: {
          text: 'Device Status',
          align: 'left'
        },
        fill:{
          colors: defaultColors,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          width: "100%",
          height: 110,
          markers: {
            fillColors: defaultColors,
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " : ",
              opts.w.globals.series[opts.seriesIndex],
            ];
          },
        },
        plotOptions: {
          pie:{
            expandOnClick: true,
            donut: {
              labels: {
                show:true,
                name:{
                  show:false
                },
                value:{
                  show:true
                },
                total: {
                  show: true,
                  showAlways:true,
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  },
                },
              },
            },
          }
        },
      }

      let options_chart2 = {
        labels: [],
        stroke: { width: 0 },
        title: {
          text: 'Device Owners',
          align: 'left'
        },
        fill:{
          colors: defaultColors,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          width: "100%",
          height: 110,
          markers: {
            fillColors: defaultColors,
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " : ",
              opts.w.globals.series[opts.seriesIndex],
            ];
          },
        },
        plotOptions: {
          pie:{
            expandOnClick: true,
            donut: {
              labels: {
                show:true,
                name:{
                  show:false
                },
                value:{
                  show:true
                },
                total: {
                  show: true,
                  showAlways:true,
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  },
                },
              },
            },
          }
        },
      }

      let options_chart3 = {
          chart: {
              type: 'line',
              dropShadow: defaultDropShadow,
          },
          stroke:defaultStroke,
          colors: defaultColors,
          xaxis: {
          }
      }

      let series_chart1 = []
      let _category_chart1 = []

      let series_chart2 = []
      let _category_chart2 = []

      let series_chart3 = []
      let _category_chart3 = []

      // 获取activity 的数据
      getActivityPie({start:"",end:"",custom_id:0}).then(res=>{
        if(res.data.code === 200 ){
            let ret = res.data.data
            let category = ["","active","standby","inactive","lock"]
            for(let i = 0 ;i < ret.length;i++){
              _category_chart1.push(category[ret[i].stat_type])
                series_chart1.push(ret[i].nums)
            }
        }
      }).catch(err=>{
        message.error(err)
      })

      getDeviceNumsByCid({start:"",end:"",custom_id:0}).then(res=>{
        if(res.data.code === 200){
          let ret = res.data.data
          for(let i = 0 ;i < ret.length;i++){
            _category_chart2.push(ret[i].name)
              series_chart2.push(ret[i].nums)
          }

        }
      }).catch(err=>{
        message.error(err)
      })

      // activity daily line
      getDeviceActivityDaily({start:"",end:"",custom_id:0}).then(res=>{
        if(res.data.code === 200){
          var ret = res.data.data
          let retObj = {}
          ret.forEach(item=>{
            const {stat_date,stat_type,nums} = item
            let statDate = formatDateString(stat_date)
            if(!_category_chart3.includes(statDate)){
              _category_chart3.push(statDate)
            }
            if (!retObj[stat_date]) {
              retObj[stat_date] = {};
            }
            retObj[stat_date][stat_type] = nums;

          })
          let statTypes = [1,2,3,4]
          const cleanedData = Object.keys(retObj).map(date => {
            const entry = { stat_date: date };
            statTypes.forEach(type => {
                entry[type] = retObj[date][type] || 0; // 如果不存在则设为 0
            });
            return entry;
        });

          // // 循环配置数据
          let activity_data = []
          let standby_data = []
          let inactivity_data = []
          let lock_data = []
          cleanedData.forEach(item=>{
            activity_data.push(item[1])
            standby_data.push(item[2])
            inactivity_data.push(item[3])
            lock_data.push(item[4])
          })

          let activity_series = {}
          let standby_series = {}
          let inactivity_series = {}
          let lock_series = {}

          activity_series.name = "Activity"
          activity_series.data = activity_data
          series_chart3.push(activity_series)

          standby_series.name = "Standby"
          standby_series.data = standby_data
          series_chart3.push(standby_series)

          inactivity_series.name = "Inactivity"
          inactivity_series.data = inactivity_data
          series_chart3.push(inactivity_series)

          lock_series.name = "Lock"
          lock_series.data = lock_data
          series_chart3.push(lock_series)
        }
      }).catch(err=>{
        message.error(err)
      })

      let data = storage.get(configs.cache.tokenKey)
      let group_id = data.group_id
      let customList = [];
      getGroup({id:group_id}).then(res=>{
          if(res.data.code == 200){
              customList = res.data.data.customs
          }else{
              message.error(res.data.msg)
          }

      }).catch(err=>{
          message.error(err)
      })
    

      setTimeout(() => {
        options_chart1.labels = [..._category_chart1]
        options_chart2.labels = [..._category_chart2]
        options_chart3.xaxis.categories = [..._category_chart3]
        this.setState({
          options_chart1:options_chart1,
          series_chart1:series_chart1,
          options_chart2:options_chart2,
          series_chart2:series_chart2,
          options_chart3:options_chart3,
          series_chart3:series_chart3,
          customList:customList
        })

      }, 500);
    }

    handlerCustomChange = (item)=>{
      this.setState({
          filterCustom:item.value
      })
    }
    handlerDateChange = (date,dtString) =>{
        console.log(dtString)
        this.setState({
            filterDate:dtString
        })
    }

  handlerSearch =()=>{
      let custom = this.state.filterCustom
      let start = this.state.filterDate.length ==2 ? this.state.filterDate[0] : "";
      let end = this.state.filterDate.length ==2 ? this.state.filterDate[1] : "";

      let options_chart1 = {
        labels: [],
        stroke: { width: 0 },
        title: {
          text: 'Device Status',
          align: 'left'
        },
        fill:{
          colors: defaultColors,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          width: "100%",
          height: 110,
          markers: {
            fillColors: defaultColors,
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " : ",
              opts.w.globals.series[opts.seriesIndex],
            ];
          },
        },
        plotOptions: {
          pie:{
            expandOnClick: true,
            donut: {
              labels: {
                show:true,
                name:{
                  show:false
                },
                value:{
                  show:true
                },
                total: {
                  show: true,
                  showAlways:true,
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  },
                },
              },
            },
          }
        },
      }

      let options_chart2 = {
        labels: [],
        stroke: { width: 0 },
        title: {
          text: 'Device Owners',
          align: 'left'
        },
        fill:{
          colors: defaultColors,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          width: "100%",
          height: 110,
          markers: {
            fillColors: defaultColors,
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " : ",
              opts.w.globals.series[opts.seriesIndex],
            ];
          },
        },
        plotOptions: {
          pie:{
            expandOnClick: true,
            donut: {
              labels: {
                show:true,
                name:{
                  show:false
                },
                value:{
                  show:true
                },
                total: {
                  show: true,
                  showAlways:true,
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  },
                },
              },
            },
          }
        },
      }

      let options_chart3 = {
          chart: {
              type: 'line',
              dropShadow: defaultDropShadow,
          },
          stroke:defaultStroke,
          colors: defaultColors,
          xaxis: {
          }
      }

      let series_chart1 = []
      let _category_chart1 = []

      let series_chart2 = []
      let _category_chart2 = []

      let series_chart3 = []
      let _category_chart3 = []

      // 获取activity 的数据
      getActivityPie({start:start,end:end,custom_id:custom}).then(res=>{
        if(res.data.code === 200 ){
            let ret = res.data.data
            let category = ["","active","standby","inactive","lock"]
            for(let i = 0 ;i < ret.length;i++){
              _category_chart1.push(category[ret[i].stat_type])
                series_chart1.push(ret[i].nums)
            }
        }
      }).catch(err=>{
        message.error(err)
      })

      // activity daily line
      getDeviceActivityDaily({start:start,end:end,custom_id:custom}).then(res=>{
        if(res.data.code === 200){
          var ret = res.data.data
          let retObj = {}
          ret.forEach(item=>{
            const {stat_date,stat_type,nums} = item
            let statDate = formatDateString(stat_date)
            if(!_category_chart3.includes(statDate)){
              _category_chart3.push(statDate)
            }
            if (!retObj[stat_date]) {
              retObj[stat_date] = {};
            }
            retObj[stat_date][stat_type] = nums;

          })
          let statTypes = [1,2,3,4]
          const cleanedData = Object.keys(retObj).map(date => {
            const entry = { stat_date: date };
            statTypes.forEach(type => {
                entry[type] = retObj[date][type] || 0; // 如果不存在则设为 0
            });
            return entry;
        });

          // // 循环配置数据
          let activity_data = []
          let standby_data = []
          let inactivity_data = []
          let lock_data = []
          cleanedData.forEach(item=>{
            activity_data.push(item[1])
            standby_data.push(item[2])
            inactivity_data.push(item[3])
            lock_data.push(item[4])
          })

          let activity_series = {}
          let standby_series = {}
          let inactivity_series = {}
          let lock_series = {}

          activity_series.name = "Activity"
          activity_series.data = activity_data
          series_chart3.push(activity_series)

          standby_series.name = "Standby"
          standby_series.data = standby_data
          series_chart3.push(standby_series)

          inactivity_series.name = "Inactivity"
          inactivity_series.data = inactivity_data
          series_chart3.push(inactivity_series)

          lock_series.name = "Lock"
          lock_series.data = lock_data
          series_chart3.push(lock_series)
        }
      }).catch(err=>{
        message.error(err)
      })


      setTimeout(() => {
        options_chart1.labels = [..._category_chart1]
        options_chart3.xaxis.categories = [..._category_chart3]
        this.setState({
          options_chart1:options_chart1,
          series_chart1:series_chart1,
          options_chart3:options_chart3,
          series_chart3:series_chart3,
        })

      }, 500);
  }
    render(){
      const {customList}  = this.state;
        return(
            <>
            <Title>Activity</Title>
            <Row gutter={[24, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
                <Card bordered={false} className="criclebox h-full">
                <Chart
                    options={this.state.options_chart3}
                    series={this.state.series_chart3}
                    type="line"
                    width="100%"
                    height={"400px"}
            
                />
                </Card>
              </Col>
            </Row>
            <Divider />
            <Row gutter={[24, 0]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mb-24">
                <Card bordered={false} className="criclebox h-full">
                <Chart
                    options={this.state.options_chart1}
                    series={this.state.series_chart1}
                    type="donut"
                    width="100%"
                    height="400px"
                />
                </Card>
              </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mb-24">
                    <Card bordered={false} className="criclebox h-full">
                    <Chart
                        options={this.state.options_chart2}
                        series={this.state.series_chart2}
                        type="donut"
                        height="400px"
                    />
                </Card>
              </Col>
            </Row>
            <Divider />
            <Form  name="horizontal_login" layout="inline"  ref={this.formRef} >
                <Form.Item
                    name="date"
                >
                   <RangePicker 
                    onChange={this.handlerDateChange}
                    format="YYYY-MM-DD" />
                </Form.Item>

                    <Form.Item name={'name'}>
                        <Select 
                         placeholder={"Please Chosen a Custom  Id"}
                         onChange={this.handlerCustomChange}
                         labelInValue
                          >
                        <Option key={0} value={0} >
                            All
                        </Option>
                        {customList.length > 0  && customList.map((items) => {
                                return (<Option key={items.id} value={items.id}>{items.name}</Option>)
                        })}

                        </Select>
                    </Form.Item> 
                    <Form.Item shouldUpdate>
       
                    <Button
                        type="primary"
                        style={{background: "#851dd6" }}
                        onClick={this.handlerSearch}
                    >
                       Filter
                    </Button>
     
                    </Form.Item>
            </Form> 
            </>
        )
    }
}

export default DashBoardActivity;
